import { Component } from '@angular/core';
import { BaseControlComponent } from '../../../../../../form-controls/components/base-control/base-control.component';
import { ContextInteractionService } from '../../../../../../form-controls/services/context-interaction.service';


@Component({
    selector: 'app-textual-display-config',
    templateUrl: './textual-display-config.component.html',
    standalone: false
})
export class TextualDisplayConfigComponent extends BaseControlComponent {
    static componentName = 'TextualDisplayConfigComponent';

    constructor(public readonly contextService: ContextInteractionService) { super(contextService); }


}